(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allura-lymphatic-age-chart"] && !Shopify.designMode) return;
  try {
    
(() => {
  const charts = document.querySelectorAll('[data-allura-age-chart]');
  const mix = (from, to, amount) => Math.round(from + (to - from) * amount);
  charts.forEach((chart) => {
    const range = chart.querySelector('[data-age-range]');
    const output = chart.querySelector('[data-age-output]');
    const pulse = chart.querySelector('[data-thumb-pulse]');
    const live = chart.querySelector('[data-live]');
    const state = chart.querySelector('[data-state]');
    const minAge = Number(chart.dataset.min || range.min || 20);
    const maxAge = Number(chart.dataset.max || range.max || 80);
    const years = chart.dataset.yearsWord || 'anni';
    const stateDefaults = ['drenaggio efficiente', 'drenaggio in lieve calo', 'drenaggio in calo', 'drenaggio più lento'];
    const stateLabels = [1, 2, 3, 4].map((n, i) => chart.getAttribute('data-state-' + n) || stateDefaults[i]);
    const stateFor = (age) => {
      const t = (age - minAge) / (maxAge - minAge);
      const i = Number.isFinite(t) ? Math.max(0, Math.min(3, Math.floor(t * 4))) : 0;
      return stateLabels[i] || stateDefaults[i];
    };
    const touch = () => chart.classList.add('is-touched');
    // Curva illustrativa: resta alta e quasi piatta fino all'età "knee" (35), poi crolla in modo netto e continuo. L'etichetta sta a sinistra del punto, dove il grafico è vuoto.
    const knee = Number(chart.dataset.knee || 35);
    const kneeT = Math.max(0.05, Math.min(0.9, (knee - minAge) / (maxAge - minAge)));
    const sig = (t) => 1 / (1 + Math.exp(-(t - (kneeT + 0.04)) / 0.03));
    const sig0 = sig(0), sig1 = sig(1);
    const drop = (t) => 0.04 * t + 0.56 * (sig(t) - sig0) / (sig1 - sig0) + 0.4 * Math.max(0, (t - kneeT) / (1 - kneeT));
    const showKnee = knee > minAge + 2 && knee < maxAge - 2;
    const desktop = { x: (t) => 145 + 690 * t, y: (t) => 171 + 211 * drop(t), band: chart.querySelector('[data-band]'), trend: chart.querySelector('[data-trend]'), marker: chart.querySelector('[data-marker]'), guide: chart.querySelector('[data-guide]'), halo: chart.querySelector('[data-halo]'), dot: chart.querySelector('[data-dot]'), pill: chart.querySelector('[data-pill]'), pillText: chart.querySelector('[data-pill-text]') };
    const mobile = { x: (t) => 48 + 347 * t, y: (t) => 135 + 178 * drop(t), band: chart.querySelector('[data-mobile-band]'), trend: chart.querySelector('[data-mobile-trend]'), marker: chart.querySelector('[data-mobile-marker]'), guide: chart.querySelector('[data-mobile-guide]'), halo: chart.querySelector('[data-mobile-halo]'), dot: chart.querySelector('[data-mobile-dot]') };
    const points = Array.from({ length: 81 }, (_, index) => index / 80);
    const setPath = (item, upperDistance, lowerDistance, lowerMax) => {
      item.trend.setAttribute('d', points.map((point, index) => `${index ? 'L' : 'M'}${item.x(point).toFixed(1)} ${item.y(point).toFixed(1)}`).join(' '));
      const upper = points.map((point, index) => `${index ? 'L' : 'M'}${item.x(point).toFixed(1)} ${(item.y(point) - upperDistance).toFixed(1)}`).join(' ');
      const lower = points.slice().reverse().map((point) => `L${item.x(point).toFixed(1)} ${Math.min(item.y(point) + lowerDistance, lowerMax).toFixed(1)}`).join(' ');
      item.band.setAttribute('d', `${upper} ${lower} Z`);
    };
    setPath(desktop, 67, 57, 430);
    setPath(mobile, 49, 43, 352);
    const placeKnee = (item, line, dot, t1, t2, lineEndY, gap) => {
      if (!line || !showKnee) { const g = line && line.parentNode; if (g) g.style.display = 'none'; return; }
      const kx = item.x(kneeT);
      let ky = item.y(kneeT);
      // Il punto va sempre sulla linea tratteggiata: leggo la y direttamente dal tracciato disegnato.
      try {
        const total = item.trend.getTotalLength();
        let lo = 0, hi = total;
        for (let k = 0; k < 24; k++) { const mid = (lo + hi) / 2; if (item.trend.getPointAtLength(mid).x < kx) lo = mid; else hi = mid; }
        const py = item.trend.getPointAtLength(hi).y;
        if (Number.isFinite(py)) ky = py;
      } catch (e) { /* tracciato non misurabile: uso la formula */ }
      line.setAttribute('x1', kx); line.setAttribute('x2', kx); line.setAttribute('y1', ky);
      dot.setAttribute('cx', kx); dot.setAttribute('cy', ky);
      t1.setAttribute('x', kx - gap); t2.setAttribute('x', kx - gap); t1.setAttribute('text-anchor', 'end'); t2.setAttribute('text-anchor', 'end');
    };
    placeKnee(desktop, chart.querySelector('[data-knee-line]'), chart.querySelector('[data-knee-dot]'), chart.querySelector('[data-knee-t1]'), chart.querySelector('[data-knee-t2]'), 435, 12);
    placeKnee(mobile, chart.querySelector('[data-mobile-knee-line]'), chart.querySelector('[data-mobile-knee-dot]'), chart.querySelector('[data-mobile-knee-t1]'), chart.querySelector('[data-mobile-knee-t2]'), 356, 10);
    const setMarker = (item, age, showPill) => {
      const t = (age - minAge) / (maxAge - minAge);
      const cx = item.x(t);
      const cy = item.y(t);
      const red = mix(39, 196, t);
      const green = mix(130, 73, t);
      const blue = mix(84, 75, t);
      item.guide.setAttribute('x1', cx);
      item.guide.setAttribute('x2', cx);
      item.halo.setAttribute('cx', cx);
      item.halo.setAttribute('cy', cy);
      item.dot.setAttribute('cx', cx);
      item.dot.setAttribute('cy', cy);
      item.dot.setAttribute('fill', `rgb(${red}, ${green}, ${blue})`);
      if (showPill) {
        const px = Math.max(196, Math.min(784, cx));
        item.pill.setAttribute('x', px - 51);
        item.pillText.setAttribute('x', px);
        item.pillText.textContent = `${age} ${years}`;
      }
    };
    function positionPulse() {
      if (!pulse) return;
      const rect = range.getBoundingClientRect();
      if (!rect.width) return;
      const thumbSize = 34;
      const usable = Math.max(rect.width - thumbSize, 0);
      const t = (Number(range.value) - minAge) / (maxAge - minAge);
      pulse.style.left = (thumbSize / 2 + t * usable) + 'px';
    }
    const setAge = (value, announce) => {
      const age = Math.max(minAge, Math.min(maxAge, Math.round(value)));
      range.value = age;
      output.textContent = `${age} ${years}`;
      if (state) state.textContent = `A ${age} ${years}: ${stateFor(age)} (tendenza generale)`;
      setMarker(desktop, age, true);
      setMarker(mobile, age, false);
      positionPulse();
      if (announce) live.textContent = output.textContent;
    };
    range.addEventListener('input', (event) => { touch(); setAge(Number(event.target.value), false); });
    range.addEventListener('change', (event) => setAge(Number(event.target.value), true));
    window.addEventListener('resize', positionPulse);
    chart.querySelector('.allura-age-chart__svg--desktop').addEventListener('pointermove', (event) => {
      const svg = event.currentTarget;
      const bounds = svg.getBoundingClientRect();
      const x = (event.clientX - bounds.left) * 960 / bounds.width;
      if (x >= 145 && x <= 835) { touch(); setAge(minAge + (x - 145) / 690 * (maxAge - minAge), false); }
    });
    setAge(Number(range.value), false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmp-age-chart-fix"] && !Shopify.designMode) return;
  try {
    
(() => {
  const charts = document.querySelectorAll('[data-allura-age-chart]');
  const mix = (from, to, amount) => Math.round(from + (to - from) * amount);
  charts.forEach((chart) => {
    const range = chart.querySelector('[data-age-range]');
    const output = chart.querySelector('[data-age-output]');
    const pulse = chart.querySelector('[data-thumb-pulse]');
    const live = chart.querySelector('[data-live]');
    const state = chart.querySelector('[data-state]');
    const minAge = Number(chart.dataset.min || range.min || 20);
    const maxAge = Number(chart.dataset.max || range.max || 80);
    const years = chart.dataset.yearsWord || 'anni';
    const stateLabels = [chart.dataset.state1, chart.dataset.state2, chart.dataset.state3, chart.dataset.state4];
    const stateFor = (age) => {
      const t = (age - minAge) / (maxAge - minAge);
      if (t < 0.25) return stateLabels[0];
      if (t < 0.5) return stateLabels[1];
      if (t < 0.75) return stateLabels[2];
      return stateLabels[3];
    };
    const touch = () => chart.classList.add('is-touched');
    const desktop = { x: (t) => 145 + 690 * t, y: (t) => 171 + 211 * Math.pow(t, 1.16), band: chart.querySelector('[data-band]'), trend: chart.querySelector('[data-trend]'), marker: chart.querySelector('[data-marker]'), guide: chart.querySelector('[data-guide]'), halo: chart.querySelector('[data-halo]'), dot: chart.querySelector('[data-dot]'), pill: chart.querySelector('[data-pill]'), pillText: chart.querySelector('[data-pill-text]') };
    const mobile = { x: (t) => 48 + 347 * t, y: (t) => 135 + 178 * Math.pow(t, 1.16), band: chart.querySelector('[data-mobile-band]'), trend: chart.querySelector('[data-mobile-trend]'), marker: chart.querySelector('[data-mobile-marker]'), guide: chart.querySelector('[data-mobile-guide]'), halo: chart.querySelector('[data-mobile-halo]'), dot: chart.querySelector('[data-mobile-dot]') };
    const points = Array.from({ length: 81 }, (_, index) => index / 80);
    const setPath = (item, upperDistance, lowerDistance, lowerMax) => {
      item.trend.setAttribute('d', points.map((point, index) => `${index ? 'L' : 'M'}${item.x(point).toFixed(1)} ${item.y(point).toFixed(1)}`).join(' '));
      const upper = points.map((point, index) => `${index ? 'L' : 'M'}${item.x(point).toFixed(1)} ${(item.y(point) - upperDistance).toFixed(1)}`).join(' ');
      const lower = points.slice().reverse().map((point) => `L${item.x(point).toFixed(1)} ${Math.min(item.y(point) + lowerDistance, lowerMax).toFixed(1)}`).join(' ');
      item.band.setAttribute('d', `${upper} ${lower} Z`);
    };
    setPath(desktop, 67, 57, 430);
    setPath(mobile, 49, 43, 352);
    const setMarker = (item, age, showPill) => {
      const t = (age - minAge) / (maxAge - minAge);
      const cx = item.x(t);
      const cy = item.y(t);
      const red = mix(39, 196, t);
      const green = mix(130, 73, t);
      const blue = mix(84, 75, t);
      item.guide.setAttribute('x1', cx);
      item.guide.setAttribute('x2', cx);
      item.halo.setAttribute('cx', cx);
      item.halo.setAttribute('cy', cy);
      item.dot.setAttribute('cx', cx);
      item.dot.setAttribute('cy', cy);
      item.dot.setAttribute('fill', `rgb(${red}, ${green}, ${blue})`);
      if (showPill) {
        const px = Math.max(196, Math.min(784, cx));
        item.pill.setAttribute('x', px - 51);
        item.pillText.setAttribute('x', px);
        item.pillText.textContent = `${age} ${years}`;
      }
    };
    function positionPulse() {
      if (!pulse) return;
      const rect = range.getBoundingClientRect();
      if (!rect.width) return;
      const thumbSize = 34;
      const usable = Math.max(rect.width - thumbSize, 0);
      const t = (Number(range.value) - minAge) / (maxAge - minAge);
      pulse.style.left = (thumbSize / 2 + t * usable) + 'px';
    }
    const setAge = (value, announce) => {
      const age = Math.max(minAge, Math.min(maxAge, Math.round(value)));
      range.value = age;
      output.textContent = `${age} ${years}`;
      if (state) state.textContent = `A ${age} ${years}: ${stateFor(age)} (tendenza generale)`;
      setMarker(desktop, age, true);
      setMarker(mobile, age, false);
      positionPulse();
      if (announce) live.textContent = output.textContent;
    };
    range.addEventListener('input', (event) => { touch(); setAge(Number(event.target.value), false); });
    range.addEventListener('change', (event) => setAge(Number(event.target.value), true));
    window.addEventListener('resize', positionPulse);
    chart.querySelector('.allura-age-chart__svg--desktop').addEventListener('pointermove', (event) => {
      const svg = event.currentTarget;
      const bounds = svg.getBoundingClientRect();
      const x = (event.clientX - bounds.left) * 960 / bounds.width;
      if (x >= 145 && x <= 835) { touch(); setAge(minAge + (x - 145) / 690 * (maxAge - minAge), false); }
    });
    setAge(Number(range.value), false);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
